/**
 * Validation Zod des réponses API (L-7).
 * En dev : avertit si la forme diverge. En prod : normalise sans bloquer l'UX.
 */

/**
 * @template {import('zod').ZodTypeAny} T
 * @param {T} schema
 * @param {unknown} data
 * @param {{ label?: string }} [options]
 * @returns {{ success: true, data: import('zod').infer<T> } | { success: false, error: import('zod').ZodError, data: unknown }}
 */
export function safeParseApiResponse(schema, data, { label = 'API' } = {}) {
  const result = schema.safeParse(data);
  if (result.success) {
    return { success: true, data: result.data };
  }

  if (process.env.NODE_ENV === 'development') {
    console.warn(`[${label}] Réponse API inattendue`, result.error.flatten());
  }

  return { success: false, error: result.error, data };
}
